import { AdminConsultsTable } from '../adminConsultsTable/adminConsultsTable.component.js';

export const AdminConsults = () => {
  return (
    <AdminConsultsTable />
  )
}